var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imports-screen"},[_c('div',{staticClass:"imports-screen__tabs"},_vm._l((_vm.getFilteredTabs),function(tab){return _c('span',{key:tab.name,staticClass:"imports-screen__tab",class:[
      _vm.isSuperAdmin && 'pointer',
      (_vm.isSuperAdmin && tab.name === _vm.selectedTab) && 'imports-screen__tab_selected'
    ],on:{"click":function($event){return _vm.changeTab(tab)}}},[_vm._v(" "+_vm._s(_vm.$t(tab.name))+" ")])}),0),_c('Imports',{attrs:{"imports-data":_vm.getImportsData,"selected-tab":_vm.selectedTab}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }